import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { shallowRef, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppLayoutDefault from './AppLayoutDefault.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const route = useRoute()
const layout = shallowRef<any>(null)

watch(
  () => route.meta,
  async (meta) => {
    try {
      const component = await import(`./${meta.layout}.vue`)
      layout.value = component?.default || AppLayoutDefault
    } catch (e) {
      layout.value = AppLayoutDefault
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value)))
}
}

})